<template>
  <div>
    <header-applis index-progression-courante="4" sous-titre="Vous êtes salarié de droit privé" titre="Connaître votre projet"/>
    <div class="wrapper__content">
      <ul>
        <li>
          <p>Si vous ne l’avez pas encore fait,</p>
          <ul>
            <li>activez votre compte personnel de formation et consultez de combien il est crédité : <a href="https://www.moncompteformation.gouv.fr/espace-prive/" target="_blank">www.moncompteformation.gouv.fr/espace-prive/</a>
            </li>
            <li>contactez votre employeur pour savoir si un financement ou co-financement est possible</li>
            <li>prenez contact avec votre opérateur Conseil en Évolution Professionnelle (CEP) pour finaliser le montage financier de votre formation : <a href="https://www.mon-cep.org/" target="_blank">www.mon-cep.org</a>
            </li>
            <li>cependant, si vous envisagez un contrat en alternance (apprentissage, professionnalisation) et que le diplôme permet cette possibilité, vous pourrez joindre directement le service de formation indiqué</li>
          </ul>
        </li>
      </ul>
    </div>
    <footer-applis ecran-precedent="choixstatutfinancement" ecran-suivant="fin" label-suivant="Terminer"/>
  </div>
</template>

<script>
import HeaderApplis from '../../components/HeaderApplis';
import FooterApplis from '../../components/FooterApplis';

export default {
  name: 'salariedroitprivefinancement',
  components: {
    FooterApplis,
    HeaderApplis
  }
}
</script>
